import { useState } from "react";
import { ICity } from "../utils/interfaces";
import { getCitiesAutoComplete } from "../../../services/questionService";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { setCitySearch } from "../../../redux/searchUsers";

// interface SelectCityProps {
//   onSelectedCity: (selectedCity: ICity) => void;
// }

const SelectCity = () =>
  // { onSelectedCity }: SelectCityProps

  {
    // const [selectedCity, setSelectedCity] = useState<ICity>();
    const [cityText, setCityText] = useState("");
    const [citiesSuggestions, setCitiesSuggestions] = useState<ICity[]>([]);
    const [citySuggestionsBoxIsOpen, setCitySuggestionsBoxIsOpen] =
      useState<boolean>(false);

    const dispatch = useDispatch();
    const searchUsers = useSelector((state: RootState) => state.searchUsers);

    const handleInputChange = async (text: string) => {
      console.log("handleInputChange text:", text);

      setCityText(text);

      if (text && text.length > 0) {
        const { data } = await getCitiesAutoComplete(text);
        console.log("handleInputChange getCitiesAutoComplete data: ", data);

        setCitiesSuggestions(data.splice(0, 5));
        setCitySuggestionsBoxIsOpen(true);
      } else {
        setCitySuggestionsBoxIsOpen(false);
      }
      // setSelectedCity(undefined);

      dispatch(setCitySearch(undefined));
    };

    const handleCitySelectFromSuggestions = (option: ICity) => {
      const cityOption = { ...option, cityName: option.cityName.trim() };

      // setSelectedCity(cityOption);
      setCitySuggestionsBoxIsOpen(false);

      dispatch(setCitySearch(cityOption));

      //TODO: Remove it because you did a searchUser State in Redux
      // onSelectedCity(cityOption);
    };

    return (
      <>
        <div className="search_form_plate">
          <div className="field_block">
            <label htmlFor="field-5" className="search_label">
              לפי עיר
            </label>
            <input
              autoComplete="off"
              className="txt_field w-input"
              maxLength={256}
              name="field-5"
              data-name="Field 5"
              placeholder="בחר ישוב או עיר"
              type="text"
              id="field-5"
              onChange={(e) => {
                handleInputChange(e.target.value);
              }}
              // value={selectedCity?.cityName}
              // value={searchUsers.city?.cityName}

              value={searchUsers.city?.cityName || cityText}
            />

            <div className="form_allert">----------------------------</div>
          </div>
        </div>

        {citySuggestionsBoxIsOpen && citiesSuggestions.length > 0 && (
          <div
            className="form_field_content"
            style={{ backgroundColor: "white", borderRadius: 5 }}
          >
            {citiesSuggestions.map((suggestion) => (
              <div key={suggestion.id}>
                <div
                  onClick={() => handleCitySelectFromSuggestions(suggestion)}
                  style={{
                    fontSize: 20,
                    padding: 10,
                    borderBottom: "1px solid rgba(0, 0, 0, 0.10)",
                  }}
                >
                  {suggestion.cityName}
                </div>
              </div>
            ))}
          </div>
        )}
      </>
    );
  };

export default SelectCity;
